import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import LockIcon from '@material-ui/icons/Lock';
import PublicIcon from '@material-ui/icons/Public';
import LinkIcon from '@material-ui/icons/Link';

// assets
import CssCollectionPrivacyStatus from './CollectionPrivacyStatus.scss';

function CollectionPrivacyStatus(props) {
  const { visibility } = props;
  useStyles(CssCollectionPrivacyStatus);

  let text;
  let icon;

  if (visibility === 'public') {
    icon = <PublicIcon color="primary" fontSize="small" style={{ marginBottom: -2 }} />;
    text = 'Public';
  } else if (visibility === 'unlisted') {
    icon = <LinkIcon color="primary" fontSize="small" style={{ marginBottom: -2 }} />;
    text = 'Unlisted';
  } else {
    icon = <LockIcon color="primary" fontSize="small" style={{ marginBottom: -2 }} />;
    text = 'Private';
  }
  return (
    <div className="collection-privacy-status">
      {icon} <span className="collection-privacy-status__text">{text}</span>
    </div>
  );
}

CollectionPrivacyStatus.propTypes = {
  visibility: PropTypes.oneOf(['public', 'private', 'unlisted']),
};

CollectionPrivacyStatus.defaultProps = {
  visibility: 'private',
};
export default CollectionPrivacyStatus;
